const state = {
    overtime:[],
    overtimeyear:2019,
};

const getters = {
    getOvertime: state => state.overtime,
    getOvertimeYear: state => state.overtimeyear,
};

const actions = {
    setOvertime: (store, payload) => store.commit("OVERTIME_SET",payload),
    setOvertimeYear: (store, payload) => store.commit("OVERTIMEYEAR_SET",payload),
};

const mutations = {
    OVERTIME_SET: (state, payload) => state.overtime = payload,
    OVERTIMEYEAR_SET: (state, payload) => state.overtimeyear = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};